export default function authHeader() {
    let user = JSON.parse(localStorage.getItem('user'));
    
    if (user && user.accessToken) {
      return { 'x-access-token' : "Bearer " + user.accessToken };
    } else {
      return { 'x-access-token' : "Bearer DEU_MTO_RUIM"};
    }
  }